import React, { Component } from 'react';
import { withRouter, setCookie, setSearchCookie, getCookie, loginUrl, pocketUrl, LoadingSpinner } from './include/Common';
import $ from 'jquery';
import axios from "axios";
import Swiper from 'swiper';
import Footer from '../module/Footer';
import { Pagination, Autoplay, EffectFade } from 'swiper/modules';
import {Helmet} from 'react-helmet';

import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';
//
class Search extends Component {
   constructor(props) {
      super(props);
      const stored = getCookie('searchHistory') || [];
      this.state = {
         totalCount: 0,
         totalNewsCount: 0,
         wordList: [],     // 배열 데이터를 담음
         newsList: [],     // 배열 데이터를 담음
         relatedList: [],
         loading: true,
         page: 1,
         keyword: '',
         searchHistory: stored,
         autoSave: getCookie('pocketAuto'),
         error: null
      };
   } 

   addSearchHistory = (keyword) => {
      if (this.state.autoSave == 'on') {
         this.setState((prevState) => {
            const updated = [keyword, ...prevState.searchHistory.filter(k => k !== keyword)].slice(0, 10);
            setSearchCookie('searchHistory', updated, { path: '/' });
            return { searchHistory: updated };
         });
      }
   };

   componentDidMount() {
      const publicUrl = process.env.PUBLIC_URL;
      const searchKeyword = this.props.params.stext; // URL의 /Search/:stext 에 해당
      this.fetchWord(searchKeyword);
   }
   componentDidUpdate(prevProps, prevState) {
      const newKeyword = this.props.params.stext;
      const prevKeyword = prevProps.params.stext;
      if (prevState.wordList !== this.state.wordList) {
         setTimeout(() => {
            const container = document.querySelector('.search-result-card .swiper-container');
            if (container) {
               if (this.swiper) {
                  this.swiper.update(); // 이미 존재하면 업데이트만
               } else {
                  this.initSwiper(); // 처음이면 초기화
               }
            } else {
               console.warn('swiper-container가 아직 DOM에 없습니다.');
            }
         }, 50);
      }
      if (prevKeyword !== newKeyword && this.state.searchKeyword !== newKeyword) {

         this.setState({ searchKeyword: newKeyword }, () => {
            this.fetchWord(newKeyword);
         });
      }
   }

   async fetchWord(searchKeyword) {
      const publicUrl = process.env.PUBLIC_URL;
      $('#searchText').val(searchKeyword);
      const pocketAuto = getCookie('pocketAuto');
      if (pocketAuto === 'on') {
         this.addSearchHistory(searchKeyword);
      }

      // 예: axios 요청 가능
      try {
         const wordRes = await axios.get(publicUrl + '/api/searchWord.php?stext=' + searchKeyword);
         const wordData = wordRes.data;
         const wordItems = (typeof wordData !== 'object' || wordData === null || wordData === 'NO')
            ? []
            : Object.keys(wordData)
               .filter(key => !isNaN(key))
               .map(key => wordData[key]);
         /*
            const wordItems = Object.keys(wordData)
               .filter(key => !isNaN(key))
               .map(key => wordData[key]);
               */
         const newsRes = await axios.get(publicUrl + '/api/searchESmodule.php?keyword=' + searchKeyword + '&pg=' + this.state.page);
         const newsData = newsRes.data;

         let newsItems = Object.keys(newsData)
            .filter(key => !isNaN(key))
            .map(key => newsData[key]);

         const relatedRes = await axios.get(publicUrl + '/api/getRelatedWord.php?term=' + searchKeyword);

         const relatedItems = Object.keys(relatedRes)
            .filter(key => !isNaN(key))
            .map(key => relatedRes[key]);

         let checkWordRelated = true;
         if (wordData == 'NO' && relatedRes.data == '') {
            checkWordRelated = false;
         }

         this.setState({
            totalCount: wordData.total,
            totalNewsCount: checkWordRelated ? newsData.total : 0,
            wordList: wordItems,
            newsList: checkWordRelated ? newsItems : [],
            relatedList: relatedRes.data,
            loading: false,
            keyword: searchKeyword,
         });

      } catch (error) {
         this.setState({
            error: error.message,
            loading: false,
            keyword: searchKeyword,
         });
      };
   }

   async fetchMoreNews(keyword, page) {
      const nextPage = page + 1;
      const publicUrl = process.env.PUBLIC_URL;
      try {
         const newsRes = await axios.get(`${publicUrl}/api/searchESmodule.php?keyword=${keyword}&pg=${nextPage}`);
         const newsData = newsRes.data;
         const newsItems = Object.keys(newsData)
            .filter(key => !isNaN(key))
            .map(key => newsData[key]);
         if (Number(newsData.total) < (Number(nextPage) * 10)) {
            $('.article-list__more').hide();
         }
         this.setState(prevState => ({
            newsList: [...prevState.newsList, ...newsItems], // 기존 리스트에 추가
            page: nextPage,
            loading: false,
         }));
      } catch (error) {
         this.setState({
            error: error.message,
            loading: false,
         });
      }
   };
   handleSearchClick = (e) => {
      e.preventDefault(); // a 태그의 기본 동작 막기
      const { totalCount, totalNewsCount, wordList, newsList, loading, page, keyword, error } = this.state;
      const trimmedKeyword = keyword.trim(); // 앞뒤 공백 제거

      if (!trimmedKeyword || trimmedKeyword == '') {
         alert("검색어를 입력해주세요.");
         return; // 아무 것도 하지 않음
      }
      this.props.navigate(`/Search/${encodeURIComponent(trimmedKeyword)}`);
      window.scrollTo({ top: 0, behavior: 'smooth' });
   }
   handleSearchChange = (e) => {
      this.setState({ keyword: e.target.value });
   }
   highlightTerm(text, keyword) {
      if (!keyword || !text) return text;

      // 정규식 특수문자 escape
      const escapeRegex = s => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

      // 키워드를 글자 단위로 분해
      const chars = [...keyword].map(ch => escapeRegex(ch));

      // 글자 사이에 공백/특수문자 허용
      // \s : 공백
      // [^가-힣a-zA-Z0-9] : 한글/영문/숫자 제외한 특수문자
      const pattern = chars.join('[\\s\\W]*');

      const regex = new RegExp(`(${pattern})`, 'gi');

      return text.replace(regex, '<em>$1</em>');
   }
   handleButtonClick = async (targetIdx) => {
      const element = document.getElementById(`btn-${targetIdx}`);

      // 모바일 iOS에서 터치시 포커스 해제 및 호버 상태 해제
      element.blur();  // 포커스 해제
      element.classList.remove('hover');  // 호버 상태 제거 (클래스가 적용되어 있을 경우)

      const { wordList } = this.state;
      const foundIndex = wordList.findIndex(item => item.idx === targetIdx);
      if (foundIndex === -1) return;

      const isZzim = wordList[foundIndex].uzzim;
      const md = isZzim ? 'unsetZzim' : 'setZzim';

      try {
         const ret = await setWord(md, targetIdx, this.state.keyword);

         const newZzim = ret === 'setZzim';

         // 클래스 업데이트
         element.classList.remove('active');
         void element.offsetHeight; // 강제로 reflow 발생
         if (newZzim) element.classList.add('active');
         else element.classList.remove('active');

         // 상태 업데이트
         this.setState(prev => {
            const updated = [...prev.wordList];
            updated[foundIndex] = {
               ...updated[foundIndex],
               uzzim: newZzim
            };
            return { wordList: updated };
         });

         const container = document.querySelector('.wordSwiper .swiper-container');
         if (container) {
            if (this.swiper) {
               this.swiper.update(); // 이미 존재하면 업데이트만
            } else {
               this.initSwiper(); // 처음이면 초기화
            }
         }

      } catch (err) {
         console.error('처리 실패:', err);
      }
   };
   handleClearKeyword = () => {
      this.setState({ keyword: '' });
   };

   initSwiper() {
      console.log('init swiper');
      if (this.swiper) return; // 한 번만 초기화
      this.swiper = new Swiper(".search-result-card .swiper-container", {
         speed: 1e3,
         grabCursor: true,
         loop: false,
         slidesPerView: "auto",
         centeredSlides: false,
         centeredSlidesBounds: true,
         spaceBetween: 16,
         observer: true,
         observeParents: true,

      });
   }
   render() {
      const { totalCount, totalNewsCount, wordList, newsList, relatedList, loading, page, keyword, error } = this.state;
      const searchKeyword = this.props.params.stext;
      const asiaeNewsUrl = process.env.REACT_APP_ASIA_WWW;
      const ogTitle = searchKeyword + ' - 지식포켓 검색';
      const ogDesc = '\''+searchKeyword + '\'의 검색 결과 입니다.';
      const currentUrl = window.location.href;
      const structureData = {
         "@context": "https://schema.org",
         "@type": "WebSite",
         "name": ogTitle,
         "url": currentUrl,
      }
      return loading ? <LoadingSpinner /> : (
         <>
            <Helmet>

               <title>{ogTitle}</title>
               <meta name="keywords" content="지식포켓, 뉴스 용어, 시사 용어, 오늘의 용어, 용어 검색, OX 퀴즈, 객관식 퀴즈, 십자말풀이, 시사 상식, 뉴스 해설, 용어 사전" />
               <meta name="description" content={ogDesc}/>

               <meta property="og:type" content="website" />
               <meta property="og:site_name" content="지식포켓" />
               <meta property="og:title" content={ogTitle} />
               <meta property="og:description" content={ogDesc}/>
               <meta property="og:url" content={currentUrl} />
               <meta property="og:image" content="https://cwstatic.asiae.co.kr/pocket/og_img.png" /> 
               <meta property="og:image:width" content="1200" />
               <meta property="og:image:height" content="630" />
               <meta property="og:locale" content="ko_KR" />

               <link rel="canonical" href={currentUrl}/>
               <script type="application/ld+json">
               { JSON.stringify(structureData)}
               </script>                 
               
            </Helmet>
            <main id="contents" data-page="main" className="page--main">
               <div className="container">
                  <div className="main-search">
                     <form className="main-search__form" method="post" autocomplete="off" onSubmit={this.handleSearchClick}>
                        <button type="submit" className="main-search__btn" title="검색" onClick={this.handleSearchClick} />
                        <div className="input-wrap">
                           <input type="search" className="search-input" id="searchText" placeholder="궁금한 용어를 검색해 보세요!" value={this.state.keyword} onChange={this.handleSearchChange} />
                        </div>
                        <button className="search-input__del" type="button" title="내용 삭제" style={{ display: this.state.keyword ? 'block' : 'none' }} onClick={this.handleClearKeyword}> </button>
                     </form>
                  </div>
               </div>
               <></>
               <section className="section section--search-result">
                  <div className="title-bx d-flex">
                     <h1 className="tit">검색 결과</h1>
                     <p className="desc"> 총 <em id="totalCount">{totalCount ? Number(totalCount).toLocaleString() : 0}</em>건 </p>
                  </div>

                  <div className="container">
                     <div className="search-result-card">
                        <div className="swiper-container">
                           <div className="swiper-wrapper" id="wordList">
                              {(wordList && wordList.length > 0) ? (
                                 wordList.map((item, index) => (
                                    <div key={item.id || index} className="swiper-slide item">
                                       <article className="word-card">
                                          <button
                                             id={`btn-${item.idx}`}
                                             type="button"
                                             className={`zzim ${item.uzzim ? 'active' : ''}`}
                                             onClick={() => this.handleButtonClick(item.idx)}
                                          >
                                             <svg width="24" height="22" id={`svg-${item.idx}`} viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg" fillOpacity="0">
                                                <use xlinkHref="#zzim"></use>
                                             </svg>
                                             <span className="sr-only">찜하기 해제</span>
                                          </button>
                                          <a href={item ? `/View/${item.idx}` : '#'} className="wrap">
                                             <p className="tit" dangerouslySetInnerHTML={{ __html: this.highlightTerm(item.title, searchKeyword) }} />
                                             <p className="eng">{item.subtitle}</p>
                                             <p className="desc">{item.description}</p>
                                          </a>
                                          <a href={item ? `/View/${item.idx}` : '#'} class="btn">용어 자세히 보기</a>
                                       </article>
                                    </div>
                                 ))
                              ) : (
                                 <div className="no-result">
                                    검색 결과가 없습니다.
                                 </div>
                              )}

                           </div>
                        </div>
                     </div>
                  </div>
               </section>

               <section className="section">
                  <div className="title-bx">
                     <h2 className="tit">
                        이 단어는 어때요?
                     </h2>
                  </div>
                  <div className="container">
                     <div className="word-bullet-list">
                        {(relatedList && relatedList.length > 0 && relatedList.filter(item => item.t_term.trim() !== "").length > 0) ? (
                           relatedList.map((item, index) => (
                              <a key={index} href={`/Search/${encodeURIComponent(item.t_term)}`} className="word"># {item.t_term}</a>
                           ))
                        ) : (
                           <div className="no-result">
                              검색 결과가 없습니다.
                           </div>
                        )}
                     </div>
                  </div>
               </section>

               <section className="section">
                  <div className="title-bx d-flex">
                     <h2 className="tit">관련 기사</h2>
                     <p className="desc"> 총 <em>{totalNewsCount ? Number(totalNewsCount).toLocaleString() : 0}</em>건 </p>
                  </div>
                  <div className="container">
                     <ul className="article-list">
                        {newsList.map((item, index) => {
                           const timg = item.t_img ? item.t_img.split('|')[0] : '';
                           const hasImage = !!timg;
                           const timgUrl = 'https://cwcontent.asiae.co.kr/asiaresize/120/' + timg;
                           return (
                              <li className="item" key={index}>
                                 <a href={`${asiaeNewsUrl}/article/${item.t_uid}`} target="_blank" className="link" title={item.t_title}>
                                    {hasImage && (
                                       <div className="img-bx">
                                          <img src={timgUrl} alt="" />
                                       </div>
                                    )}
                                    <div className="txt-bx">
                                       <p className="tit" dangerouslySetInnerHTML={{ __html: item.t_title }} />
                                    </div>
                                 </a>
                              </li>
                           );
                        })}
                     </ul>
                     <div className="article-list__more" style={totalNewsCount > 10 ? {} : { display: 'none' }}>
                        <button className="btn" title="더보기" onClick={() => this.fetchMoreNews(keyword, page)}>
                           더보기
                           <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                              <path d="M11.9999 7.71429H7.71416V12H6.28559V7.71429H1.99988V6.28571H6.28559V2H7.71416V6.28571H11.9999V7.71429Z" fill="black" stroke="black" />
                           </svg>
                        </button>
                     </div>
                  </div>
               </section>

               <section className="section">
                  <a href="/TodayCross" className="quiz-banner">
                     <div className="img-bx">
                        <svg width="95" height="95" viewBox="0 0 95 95" fill="none" xmlns="http://www.w3.org/2000/svg">
                           <path d="M32.9879 72.4679V88.6135C32.9879 90.387 33.609 91.8965 34.8511 93.1421C36.0967 94.3842 37.608 95.0053 39.385 95.0053H55.52C57.297 95.0053 58.8083 94.3842 60.0539 93.1421C61.296 91.8965 61.917 90.387 61.917 88.6135V72.4679C61.917 70.691 61.296 69.1797 60.0539 67.9341C58.8083 66.6919 57.297 66.0709 55.52 66.0709H39.385C37.608 66.0709 36.0967 66.6919 34.8511 67.9341C33.609 69.1797 32.9879 70.691 32.9879 72.4679ZM28.9238 55.615V39.48C28.9238 37.703 28.3028 36.1935 27.0607 34.9514C25.8186 33.7058 24.309 33.0829 22.5321 33.0829H6.39702C4.62007 33.0829 3.10878 33.7058 1.86316 34.9514C0.621053 36.197 0 37.7065 0 39.48V55.6203C0 57.3937 0.621053 58.9033 1.86316 60.1489C3.10878 61.391 4.61831 62.0121 6.39174 62.0121H22.5374C24.3143 62.0121 25.8256 61.391 27.0712 60.1489C28.3133 58.9033 28.9344 57.3937 28.9344 55.6203M39.385 62.0121H55.5253C57.3023 62.0121 58.8135 61.391 60.0592 60.1489C61.3013 58.9033 61.9223 57.3937 61.9223 55.6203V39.48C61.9223 37.703 61.3013 36.1935 60.0592 34.9514C58.8135 33.7058 57.3023 33.0829 55.5253 33.0829H39.3902C37.6133 33.0829 36.102 33.7058 34.8564 34.9514C33.6143 36.1935 32.9932 37.703 32.9932 39.48V55.6203C32.9932 57.3937 33.6143 58.9033 34.8564 60.1489C36.102 61.391 37.6133 62.0121 39.3902 62.0121M72.3676 29.0241H88.6083C90.3817 29.0241 91.8912 28.4031 93.1368 27.161C94.3789 25.9153 95 24.4058 95 22.6324V6.39702C95 4.62007 94.3789 3.10878 93.1368 1.86316C91.8947 0.621053 90.387 0 88.6135 0H72.3623C70.5889 0 69.0794 0.621053 67.8338 1.86316C66.5917 3.10878 65.9706 4.61831 65.9706 6.39174V22.6324C65.9706 24.4093 66.5917 25.9206 67.8338 27.1662C69.0794 28.4083 70.5907 29.0294 72.3676 29.0294" fill="white" />
                           <rect x="66" y="33" width="29" height="29" rx="6" fill="#00FF99" />
                        </svg>
                     </div>
                     <div className="txt-bx">
                        <p className="desc">십자말 풀이 퀴즈 풀고 </p>
                        <h2 className="title"> <em>시사 상식 마스터 까지!</em> </h2>
                     </div>
                  </a>
               </section>
            </main>
            <Footer />
         </>
      );
   }
}
async function setWord(md, idx, keyword) {
   const publicUrl = process.env.REACT_APP_POCKET_WWW;
   setCookie('JUMP_URI', publicUrl);
   try {
      const response = await axios.get('/api/setWord.php?md=' + md + '&idx=' + idx);
      if (response.data == 'NO') {
         const refUrl = process.env.REACT_APP_USER_WWW + '/snslogin/PocketLogingDone.php?loc=Search/' + keyword + '&idx=' + idx;
         window.location.href = loginUrl + '?ref=' + encodeURIComponent(refUrl);
      }

      return response.data;
   } catch (error) {
      console.log(error.message);
      return false;
   };
}
export default withRouter(Search);